import { AutogenLayoutTaxControlVersion } from "./autogen/AutogenLayoutTaxControlVersion";
import { ClickEvent, Snackbar } from "@mcleod/components";
import { Clipboard } from "@mcleod/core";

export class TaxControlVersion extends AutogenLayoutTaxControlVersion {
    /** This is an event handler for the onClick event of imageCopy. */
    imageCopyOnClick(event: ClickEvent) {
        Clipboard.copyText(this.labelChangelog.text);
        Snackbar.showSnackbar("Log copied to clipboard!");
    }
}
